import { cn } from "../../utils/lib";

export function ArrowLeft({ className, ...props }) {
  return (
    <svg
      // xmlns="http://www.w3.org/2000/svg"
      // width="6"
      // height="10"
      viewBox="0 0 6 10"
      fill="none"
      className={cn("h-auto w-full block", className)}
      {...props}
    >
      <path
        d="M5 9L1 5L5 1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
